<template>
	<div class="confirm-modal">
		<div class="confirm-title">{{ title }}</div>
		<div class="body">{{ body }}</div>

		<b-button type="is-primary" rounded :loading="isOkButtonLoading" @click="onOkClick">{{ okButtonTitle }}</b-button>
		<b-button v-if="isCancelButtonShow" type="is-info" rounded @click="onCancelClick">キャンセル</b-button>
	</div>
</template>

<script>

export default {
	name: 'ConfirmModal',
	props: {
		title: {
			type: String,
			default: '',
		},
		body: {
			type: String,
			default: '',
		},
		okButtonTitle: {
			type: String,
			default: '',
		},
		isOkButtonLoading: {
			type: Boolean,
			default: false,
		},
		isCancelButtonShow: {
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {
		}
	},
	mounted() {
	},
	computed: {
	},
	methods: {
		onOkClick: function() {
			this.$emit('ok-click');
		},
		onCancelClick: function() {
			this.$emit('cancel-click');
		},
	},
}
</script>

<style lang="scss">

</style>
